import constant from '../../store/constant'
var utils = require('../../utils')

export default {
  name: 'facility-list',
  data: function () {
    return {
      shopId: null,
      shopList: [],
      showTabs: true,
      showTablists: true,
      showShops: true,
      showCheckshops: true,
      showLists: true,
      showButtons: true,
      nextUrl: null,
      facilityId: null,
      facilityName: '',         // 施設名
      facilityAll: true,        // 施設・その他
      facilityPerson: true,     // 個人宅
      isFacility: true,
      facilityType: null,       // 施設タイプ
      dealEnds: false,          // 取引中止先を検索するか
      telDuplicateCheck: false, // 電話番号重複チェック
      isNoneData: false,        // データなし
      utils: utils,
      watchScroll: null,
      isCheckedAll: false,      // 全選択フラグ
      // ソート
      sortKey: '',
      sortStateOrder: '',
      sortState: {
        'facility_name_furigana': {'state': true,  'order': true},
        'facility_type':          {'state': false, 'order': false},
        'tel':                    {'state': false, 'order': false}
      },
      sortStateInit: {},
      noticeFacilityId: null,
      searchCallbackFlag: false, // 検索結果フラグ
      maxShopCount: 8
    }
  },
  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    if (utils.isPresent(this) && '$store' in this) {
      if (this.$store.getters.facilitiesSearchParams !== null) {
        this.$store.getters.facilitiesSearchParams['pageYOffset'] = window.pageYOffset // スクロール位置保存
        this.$store.getters.facilitiesSearchParams['scrollHeight'] = utils.getScrollHeight() // スクロール高さ保存
      }
      if (this.watchScroll !== null) {
        this.watchScroll.disconnect()
        this.watchScroll = null
      }
    }
    utils.autocompleteEventRemove({$: $, elem:'#facility_name_autocomplete'}) // オートコンプリートイベント削除
    utils.scrollBottomSearchEventRemove() // 最下部スクロールイベント削除
    next()
  },
  created () {
    var readMore = false

    // ソート初期化用保存
    for (var k in this.sortState) {
      this.sortStateInit[k] = {}
      this.sortStateInit[k].state = this.sortState[k].state
      this.sortStateInit[k].order = this.sortState[k].order
    }

    if (this.$store.getters.canManage) {
      // 店舗ID
      this.shopId = this.$store.getters.currentShopId
    }
    // this.$store.dispatch('SHOP_SEARCH')
    this.$store.dispatch('SHOP_SEARCH', {data: {all_get: true}, 'allShopName': this._self.$t('AllShopName'), callback: () => {}})

    if (this.$router.currentRoute.query.type === 'create_report') {
      this.$store.dispatch('NS_CHECK', { data: { shop_id: this.shopId }})
    }

    if (this.$router.currentRoute.query.type === 'create_report') {
      this.showTabs = false
      this.showTablists = false
      this.showShops = false
      this.showLists = false
      this.isFacility = false
    }
    if (this.$router.currentRoute.query.type === 'reports_history') {
      this.showTablists = false
      this.showShops = false
      this.showCheckshops = false
      this.showLists = false
      var ssFacilityName = window.sessionStorage.getItem("rh-faclityName")
      if (ssFacilityName !== null) {
        this.facilityName = ssFacilityName
      }
    }
    if (this.$router.currentRoute.query.type === 'select_facility') {
      this.showTabs = false
      this.showCheckshops = false
      this.showButtons = false
      var ssShopID = window.sessionStorage.getItem("sf-shopID")
      var ssFacilityType = window.sessionStorage.getItem("sf-facilityType")
      var ssFacilityName = window.sessionStorage.getItem("sf-faclityName")
      var ssDealEnds = window.sessionStorage.getItem("sf-dealEnds")
      var ssSortKey = window.sessionStorage.getItem("sf-sortKey")
      var ssSortStateOrder = window.sessionStorage.getItem("sf-sortStateOrder")
      if (!!ssShopID) {
        if (ssShopID === 'null') {
          this.shopId = null
        } else {
          this.shopId = ssShopID
        }
      }
      if (!!ssFacilityType) {
        this.facilityType = ssFacilityType
      }
      if (!!ssFacilityName) {
        this.facilityName = ssFacilityName
      }
      if (!!ssDealEnds) {
        this.dealEnds = Boolean(ssDealEnds)
      }
      if (!!ssSortKey) {
        var key = ssSortKey
        this.sortKey = key
        if (ssSortStateOrder != null) {
          if (ssSortStateOrder === "true") {
            this.sortStateOrder = true
          } else {
            this.sortStateOrder = false
          }
        } else {
          this.sortStateOrder = !this.sortState[key].order
        }
        for (var k in this.sortState) {
          this.sortState[k].state = false
          if (k !== key) {
            this.sortState[k].order = false
          }
        }
        this.sortState[key].state = true
        this.sortState[key].order = this.sortStateOrder
      }
      this.$store.dispatch('PHRASE_SEARCH', {data:{phrase_type: constant.phraseType.FACILITY_TYPE}, type: 'combobox'})
    }
    this.search(readMore)

    // オートコンプリートイベント
    utils.autocompleteEvent({
      $:                  $,
      elem:               '#facility_name_autocomplete',
      search:             this.search,
      searchParams:       false,
      searchAutocomplete: this.getFacilities,
      setSearchData:      this.setSearchFacility,
      clear:              this.clearFacilitiesAutocomplete,
    })

    // 最下部スクロールイベント
    utils.scrollBottomSearchEvent(this.search, true, 'button.next-page-search-btn')
  },
  mounted () {
    if (this.$router.currentRoute.query.type === 'select_facility') {
      // ヘルプボタン表示
      utils.helpModalShow()
    }
  },
  computed: {
    orderedFacilities () {
      return this.facilities
    },

    /** 通知 */
    notify () {
      if (this.$store.getters.facilityEditNotify !== null) {
        return this.$store.getters.facilityEditNotify
      }
      return this.$store.getters.facilityNotify
    },
    facilities () {
      return this.$store.getters.facilities
    },
    facilitiesAutocomplete() {
      return this.$store.getters.facilitiesAutocomplete
    },
    loading () {
      return this.$store.getters.apiLoading
    },
    nextPage () {
      return this.$store.getters.facilitiesNextPage
    },
    totalCount () {
      return this.$store.getters.facilitiesTotalCount
    },
    shops () {
      return this.$store.getters.shops
    },
    /** 定型文-施設種類 を取得 */
    facilityTypes () {
      if (utils.isBlank(this.$store.getters.phraseLists) || Object.keys(this.$store.getters.phraseLists).length <= 0) {
        return null
      }
      var result = []
      var arr = this.$store.getters.phraseLists[constant.phraseType.FACILITY_TYPE]
      for (var i = 0; i < arr.length; i++) {
        if (utils.str2int(arr[i].attributes['phrase-code']) !== 1) {
          result.push(arr[i])
        }
      }
      result.unshift({id: null, attributes: {'phrase-type-id': null, 'phrase-code': null, 'phrase': this._self.$t('facility.select_none')}})
      return result
    },
    currentPage () {
      return this.$store.getters.facilitiesCurrentPage
    },
    facilityNotices () {
      return this.$store.getters.facilityNotices
    },
    /** 報告作成判定 */
    isCreateReport() {
      return this.$router.currentRoute.query.type === 'create_report'
    },
    overShopCount () {
      if (this.shopList.length > this.maxShopCount) {
        return true
      }
      return false
    },
    nsCounter () {
      return this.$store.getters.nsCounter
    }
  },
  methods: {
    // goFacilities: function () {
    //   this.$router.push({ path: '/facilities', query:{type: this.$router.currentRoute.query.type} })
    // },
    goFacilityPersons: function () {
      this.$router.push({ path: '/facility_persons', query:{type: this.$router.currentRoute.query.type} })
    },
    goClinics: function () {
      this.$router.push({ path: '/clinics', query:{type: this.$router.currentRoute.query.type} })
    },
    goDoctors: function () {
      this.$router.push({ path: '/doctors', query:{type: this.$router.currentRoute.query.type} })
    },
    goCareOffices: function () {
      this.$router.push({ path: '/care_offices', query:{type: this.$router.currentRoute.query.type} })
    },
    goCareManagers: function () {
      this.$router.push({ path: '/care_managers', query:{type: this.$router.currentRoute.query.type}})
    },
    goFacilityRegister: function () {
      this.$router.push({ path: '/facilities/edit', query: { type: this.$router.currentRoute.query.type}})
    },
    goPatients: function () {
      if (utils.isPresent(this.noticeFacilityId)) {
        this.$router.push({ path: '/patients/' + this.noticeFacilityId + '/select/', query: { type: this.$router.currentRoute.query.type}})
      }
    },
    goNext: function(id) {
      if (this.$router.currentRoute.query.type === 'create_report') {
        this.noticeFacilityId = id
        var _this = this
        var callback = function(data) {
          var notices = data.data
          if (notices != null && 0 < notices.length) {
            var button = document.getElementById('noticesConfirmModalButton')
            button.click() // モーダル表示 イベント発火
          } else {
            _this.goPatients()
          }
        }
        this.$store.dispatch('FACILITY_NOTICE_GET', { data: { facility_id: id }, callback: callback })

      } else if (this.$router.currentRoute.query.type === 'reports_history') {
        this.$router.push({ path: '/reports/history/facility/' + id, query: { type: this.$router.currentRoute.query.type}})
      } else if (this.$router.currentRoute.query.type === 'select_facility') {
        var selected = this.getCheckBoxSelected()
        this.$router.push({ path: '/facilities/detail/' + id, query: { type: this.$router.currentRoute.query.type}})
      }
    },
    goPrev: function() {
      if (this.$router.currentRoute.query.type === 'create_report') {
        this.$router.push({ path: '/', query: { type: this.$router.currentRoute.query.type}})
      } else if (this.$router.currentRoute.query.type === 'reports_history') {
        this.$router.push({ path: '/', query: { type: this.$router.currentRoute.query.type}})
      } else if (this.$router.currentRoute.query.type === 'select_facility') {
        this.$router.push({ path: '/', query: { type: this.$router.currentRoute.query.type}})
      }
    },
    onChecked: function (event) {
      this.isCheckedAll = false
      if (event) {
        var target = event.target
        this.$store.dispatch('FACILITY_CHECKED', { facility_id: target.value, checked: target.checked })
      }
    },
    onClickSurrounding: function () {
      // 全選択＋次ページ以降があれば再取得
      if (this.isCheckedAll && utils.isPresent(this.$store.getters.facilitiesNextPage)) {
        var data = {
          'shop_id':             this.shopId,
          'facility_name':       this.facilityName,
          'facility_all':        this.facilityAll ? "1" : "0",
          'facility_person':     this.facilityPerson ? "1" : "0",
          'facility_type':       this.facilityType,
          'deal_ends':           this.dealEnds ? "1" : "0",
          'tel_duplicate_check': this.telDuplicateCheck ? "1" : "0",
          'order':               this.orderByString()
        }

        if (this.$router.currentRoute.query.type === 'select_facility' || this.$router.currentRoute.query.type === 'reports_history') {
          if (window.location.href.indexOf('person') >= 0) {
            // 個人宅のみ
            data['facility_all']    = "0"
            data['facility_person'] = "1"
          } else {
            // 施設のみ
            data['facility_all']    = "1"
            data['facility_person'] = "0"
          }
        }
        this.$store.dispatch('FACILITY_SEARCH_ALL', {data: data, callback: this.goSurrounding})
      } else {
        this.goSurrounding()
      }
    },
    goSurrounding: function (data) {
      var selected = this.getCheckBoxSelected(data)

      this.$store.dispatch('FACILITY_SELECT', {selected: selected, callback: () => {
        this.$router.push({ path: '/facilities/surrounding', query: { type: this.$router.currentRoute.query.type, searchShops: false}})
      }})
    },
    getCheckBoxSelected: function (data) {
      var elm = document.querySelectorAll('input.facility-checkbox')
      var ids = []
      var excludes = []

      Array.prototype.map.apply(elm, [function (e) {
        if (e.checked) {
          ids.push(utils.str2int(e.value))
        } else {
          excludes.push(utils.str2int(e.value))
        }
      }])
      var selected = []
      for (var i = 0; i < ids.length; i++) {
        for (var j = 0; j < this.facilities.length; j++) {
          if (utils.str2int(this.facilities[j].id) === ids[i]) {
            selected.push(this.facilities[j])
            break
          }
        }
      }
      if (data != null) {
        for (var f of data.data) {
          var id = utils.str2int(f.id)
          if (ids.indexOf(id) == -1 && excludes.indexOf(id) == -1) {
            selected.push(f)
          }
        }
      }

      this.$store.getters.facilitiesSearchParams['isCheckedAll'] = this.isCheckedAll
      this.$store.getters.facilitiesSearchParams['facilitySelected'] = selected
      return selected
    },

    setSearchFacility: function (facilityId, facilityName) {
      this.facilityName = facilityName
      this.$store.dispatch('FACILITY_AUTOCOMPLETE_CLEAR', 100)
    },
    clearFacilities: function () {
      this.$store.dispatch('FACILITY_CLEAR', 0)
    },
    clearFacilitiesAutocomplete: function () {
      this.$store.dispatch('FACILITY_AUTOCOMPLETE_CLEAR', 500)
    },
    getFacilities: function () {
      this.facilityId = null
      this.search(false, 'autocomplete')
    },
    /** 電話番号重複検索 */
    telDuplicateSearch: function() {
      this.telDuplicateCheck = !this.telDuplicateCheck
      this.search(false)
    },
    /** 施設検索 */
    search: function(readMore, mode) {
      var url = null
      var clear = true
      var autocomplete = false
      var loadparams = true
      var send_fails = 0
      var self = this

      if (readMore === 'sort') {
        // ソート読み込み
        clear       = false
        loadparams  = 'block'
      } else if (readMore === 'keepload') {
        // 再読込
        clear = false
        loadparams = 'block'
        this.searchCallbackFlag = true

        // スクロール位置
        var pageYOffset = this.$store.getters.facilitiesSearchParams['pageYOffset']
        var scrollHeight = this.$store.getters.facilitiesSearchParams['scrollHeight']
        this.$store.getters.facilitiesSearchParams['pageYOffset'] = null
        this.$store.getters.facilitiesSearchParams['scrollHeight'] = null
        this.watchScroll = utils.setScrollHeight(scrollHeight, pageYOffset)
        if ('isCheckedAll' in this.$store.getters.facilitiesSearchParams) {
          if (this.$store.getters.facilitiesSearchParams['isCheckedAll'] !== null) {
            this.isCheckedAll = this.$store.getters.facilitiesSearchParams['isCheckedAll']
            this.$store.getters.facilitiesSearchParams['isCheckedAll'] = null
          }
        }
      } else if (readMore) {
        // 次ページ
        url   = this.$store.getters.facilitiesNextPage
        clear = false
        loadparams = 'block'
      } else {
        // 通常またはオートコンプリート
        if (mode !== 'autocomplete') {
          this.searchCallbackFlag = false
          this.isCheckedAll = false
          // 全選択
          if (this.$store.getters.facilitiesSearchParams !== null) {
            if ('isCheckedAll' in this.$store.getters.facilitiesSearchParams) {
              if (this.$store.getters.facilitiesSearchParams['isCheckedAll'] !== null) {
                this.isCheckedAll = this.$store.getters.facilitiesSearchParams['isCheckedAll']
                this.$store.getters.facilitiesSearchParams['isCheckedAll'] = null
              }
            }
          }
        }
      }

      if (mode === 'autocomplete') {
        autocomplete = true
        loadparams = false
        clear = false
      } else if (this.$router.currentRoute.query.type === 'reports_history') {
        send_fails = 1
      }

      var selected = null
      if (this.$store.getters.facilitiesSearchParams) {
        if (this.$store.getters.facilitiesSearchParams['facilitySelected'] !== null) {
          selected = this.$store.getters.facilitiesSearchParams['facilitySelected']
          self.$store.getters.facilitiesSearchParams['facilitySelected'] = null
        }
      }
      var callback = function () {
        if (selected) {
          if (selected.length > 0) {
            for (var i = 0; i < selected.length; i++) {
              self.$store.dispatch('FACILITY_CHECKED', { facility_id: selected[i].id, checked: true})
            }
          }
        }
        self.searchCallbackFlag = true
      }

      var data = {
        'shop_id':             this.shopId,
        'facility_name':       this.facilityName,
        'facility_all':        this.facilityAll ? "1" : "0",
        'facility_person':     this.facilityPerson ? "1" : "0",
        'send_fails':          send_fails,
        'facility_type':       this.facilityType,
        'deal_ends':           this.dealEnds ? "1" : "0",
        'tel_duplicate_check': this.telDuplicateCheck ? "1" : "0",
        'order':               this.orderByString(),
        'type':                this.$router.currentRoute.query.type
      }
      if (readMore === 'sort' || readMore === 'keepload') {
        // ソート、再読込 現在のページを指定
        data['current_page'] = this.currentPage
      } else {
        data['current_page'] = null
      }

      if (this.$router.currentRoute.query.type === 'select_facility' || this.$router.currentRoute.query.type === 'reports_history') {
        if (window.location.href.indexOf('person') >= 0) {
          // 個人宅のみ
          data['facility_all']    = "0"
          data['facility_person'] = "1"
        } else {
          // 施設のみ
          data['facility_all']    = "1"
          data['facility_person'] = "0"
        }
      }
      if (this.$router.currentRoute.query.type === 'reports_history') {
        if (this.facilityName != "") {
          window.sessionStorage.setItem("rh-faclityName", this.facilityName)
        } else {
          window.sessionStorage.removeItem("rh-faclityName")
        }
      }
      if (this.$router.currentRoute.query.type === 'select_facility') {
        window.sessionStorage.setItem("sf-shopID", this.shopId)
        if (!!this.facilityType) {
          window.sessionStorage.setItem("sf-facilityType", this.facilityType)
        } else {
          window.sessionStorage.removeItem("sf-facilityType")
        }
        if (!!this.facilityName) {
          window.sessionStorage.setItem("sf-faclityName", this.facilityName)
        } else {
          window.sessionStorage.removeItem("sf-faclityName")
        }
        if (this.dealEnds == true) {
          window.sessionStorage.setItem("sf-dealEnds", this.dealEnds)
        } else {
          window.sessionStorage.removeItem("sf-dealEnds")
        }
        if (!!this.sortKey) {
          window.sessionStorage.setItem("sf-sortKey", this.sortKey)
        } else {
          window.sessionStorage.removeItem("sf-sortKey")
        }
        if (this.sortStateOrder !== "") {
          window.sessionStorage.setItem("sf-sortStateOrder", this.sortStateOrder)
        } else {
          window.sessionStorage.removeItem("sf-sortStateOrder")
        }
      }

      this.$store.dispatch('FACILITY_SEARCH', {url: url, clear: clear, data: data, loadparams: loadparams, autocomplete: autocomplete, callback: callback, checkall: this.isCheckedAll})
    },
    /** 全施設選択 / クリア */
    selectAll: function (checked) {
      this.isCheckedAll = checked
      this.$store.dispatch('FACILITY_CHECKED', { checked: checked })
    },
    completeNotice: function (facility_notice_id) {
      this.$store.dispatch('FACILITY_NOTICE_COMPLETE', {data: {facility_notice_id: facility_notice_id}, callback: () => {}})
    },
    deleteNotice: function (facility_notice_id) {
      this.$store.dispatch('FACILITY_NOTICE_DELETE', {data: {facility_notice_id: facility_notice_id}, callback: () => {}})
    },
    /** ソート */
    sortBy: function(key) {
      this.sortKey = key
      this.sortStateOrder = !this.sortState[key].order
      for (var k in this.sortState) {
        this.sortState[k].state = false
        if (k !== key) {
          this.sortState[k].order = false
        }
      }
      this.sortState[key].state = true
      this.sortState[key].order = !this.sortState[key].order
      // 検索
      this.search('sort')
    },
    getArrow: function(key) {
      var state = this.sortState[key].state ? ' color-light-blue' : ''
      var arrow = this.sortState[key].order ? 'fa-arrow-up' : 'fa-arrow-down'
      return arrow + state
    },
    /** ソート文字列取得 */
    orderByString: function() {
      var result = []
      for (var key in this.sortState) {
        if (this.sortState[key].state) {
          var asc_desc = 'asc'
          if (!this.sortState[key].order) {
            asc_desc = 'desc'
          }
          result.push(key + ' ' + asc_desc)
        }
      }
      if (result.length <= 0) {
        // 存在しない場合
        result.push('facility_name_furigana asc')
      }
      return result.join(' , ')
    },
    // 店舗別担当施設表示
    goSurroundingSearchByShops: function() {
      if (this.overShopCount) {
        return
      }
      this.shopList.sort(function (a, b) {
        return a - b
      })
      var data = {
        'shop_list': this.shopList,
        'facility_all':        "1",
        'facility_person':     "0"
      }
      this.$store.dispatch('FACILITY_SHOP_LIST_SAVE', {data: this.shopList})
      this.$store.dispatch('FACILITY_SEARCH_BY_SHOP', {data: data, callback: () => {
        this.$router.push({ name: 'facilitySurrounding', query: { type: this.$router.currentRoute.query.type, searchShops: true} })
      }})
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/facility-list.js